<template>
    <div class="c-cart-sum" v-bind:class="{'c-cart-sum--alt': isAlt, }">
      <p class="c-cart-sum__label">{{ name }}</p>
      <p class="c-cart-sum__label">{{ value }}</p>
    </div>
</template>

<script>
export default {
  props: ['name', 'value', 'isAlt']
}
</script>



// WEBPACK FOOTER //
// src/components/BlockCart/BlockCartSummary.vue